import {
    ActionReducerMap,
    MetaReducer,
} from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { orderDetailsReducer } from './order-details.reducer';
import { OrderDetailsState } from '../states/orderDetails.state';
import { CustomerSupportState } from '../states/customer-support.state';
import { CancelContractDataState } from '../states/cancel-contract-data.state';
import { CustomerSupportReducer } from './customer-support.reducer';
import { CancelContractDataReducer } from './cancel-contract-data.reducer';
import { CustomerDetailsReducer } from './customer-details.reducer';
import {CustomerDetailsState} from '../states/customer-details.state';
/** AppState */
export interface AppState {
    /** orderDetailsState */
    orderDetailsState: OrderDetailsState;
    /** CustomerSupportState */
    customerSupportState: CustomerSupportState;
      /** cancel Contract Data State */
    cancelContractDataState: CancelContractDataState;
    /** CustomerDetailsState */
    customerDetailsState: CustomerDetailsState;
}
/** ActionReducerMap */
export const reducers: ActionReducerMap<AppState> = {
    orderDetailsState: orderDetailsReducer,
    customerSupportState: CustomerSupportReducer,
    cancelContractDataState: CancelContractDataReducer,
    customerDetailsState: CustomerDetailsReducer,
};
/** metaReducers */
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
